export default "/images/login-vector3.svg?500ed563c10faf720187ca00a297ae89";